<template>
  <div class="contact">
    <div class="contact-container">
      <h1>Contact Me</h1>
      <h4>If you have any questions, please don't hesitate to contact me using the form below.</h4>
      <form class="contact-form">
        <div class="contact-form-row1">
          <input v-model="contactName" type="text" ref="inputRef" class="contact-form-field name-field" name="name" placeholder="Name" autofocus="">
          <input v-model="contactEmail" type="text" class="contact-form-field email-field" name="email" placeholder="Email">
        </div>
        <input v-model="subject" type="text" class="contact-form-field " name="subject" placeholder="Subject">
        <textarea v-model="message" class="contact-form-field message-field" name="message" placeholder="Message"></textarea>
      </form>
      <div class="contact-btn-container">
        <button class="contact-me" role="button" @click="sendEmail()">SEND</button>
      </div>
      <p class="white-text">{{ error }}{{ success }}</p>
    </div>
  </div>
</template>

<script>
import { useFocus } from '@vueuse/core'
import axios from 'axios';
import constants from '@/assets/constants';
export default {
  name: 'Contact',
  props: ['nav'],
  data() {
    return {
      selectedNav: 'Contact',
      contactName: '',
      contactEmail: '',
      subject: '',
      message: '',
      error: '',
      success: ''
    };
  },
  watch: {
    nav(val) {
      if (val == 'Contact') {
        this.$nextTick(() => {
          useFocus(this.$refs.inputRef, { initialValue: true })
        });
      }
    }
  },
  methods: {
    async sendEmail() {
      if (this.contactName == '' || this.contactEmail == '' || this.subject == '' || this.message == '') {
        this.error = 'Please make sure all fields are filled. Thank You';
        setTimeout(() => {
          this.error = '';
        }, 5000);
      } else {
        await axios.post('/api/contact-me',
          {
            contactName: this.contactName,
            contactEmail: this.contactEmail,
            subject: this.subject,
            message: this.message
          }
        ).then(res => {
          console.log('res: ', res);
          this.contactName = '';
          this.contactEmail = '';
          this.subject = '';
          this.message = '';
          this.success = 'Your message has been sent. Thank You!'
          setTimeout(() => {
            this.error = '';
          }, 15000);
        })
      }
    }
  },
}
</script>

<style scoped>
  /* Container/Background */
  .contact {
    height: 100vh;
    display: flex;
    justify-content: center;
    overflow: hidden;
    vertical-align: middle;
  }
  .contact-container {
    position: relative;
    left: auto;
    right: auto;
    top: calc(50% - 220px);
    min-width: 200px;
    max-width: 1000px;
    h1 {
      font-size: 64px;
      color: #00eeff;
    }
    h4 {
      font-weight: 400;
      font-size: 19px;
      color: #7a7a7a;
      text-shadow: 1px 1px 4px #111;
    }
  }

  .contact-form {
    width: 100%;
    margin-top: 10px;
    input, textarea {
      font-size: 22px;
    }
  }
  .name-field {
    margin-right: 5px;
  }
  .email-field {
    margin-left: 5px;
  }
  .message-field {
    min-height: 150px;
  }
  .contact-form-field {
    background-color: rgba(255, 255, 255, 0.1); /* Transparent background */
    backdrop-filter: blur(10px); /* The key to the glass effect */
    border: 1px solid rgba(255, 255, 255, 0.3); /* Subtle border for definition */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Soft shadow for depth */
    padding: 15px;
    margin-bottom: 10px;
    border-radius: 10px;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    width: calc(100% - 30px);
    color: white;
  }
  .contact-form-row1 .contact-form-field {
    width: calc(50% - 37px);
  }

  .contact-btn-container {
    display: flex;
    justify-content: right;
    margin-right: 12px;
  }

  /* Button CSS */
  .contact-me {
    --b: 3px;   /* border thickness */
    --s: .3em; /* size of the corner */
    --color: #ff00ee;
    --color2: #00eeff;
    
    margin-left: .5em;
    margin-top: 1em;
    padding: calc(.4em + var(--s)) calc(.8em + var(--s));
    color: var(--color);
    --_p: var(--s);
    background:
      conic-gradient(from 90deg at var(--b) var(--b),#0000 90deg,var(--color2) 0)
      var(--_p) var(--_p)/calc(100% - var(--b) - 2*var(--_p)) calc(100% - var(--b) - 2*var(--_p));
    transition: .3s linear, color 0s, background-color 0s;
    outline: var(--b) solid #ff00ee;
    outline-offset: .5em;
    font-size: 20px;
    font-weight: 600;
    border: 0;

    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    cursor: pointer;
  }

  .contact-me:disabled {
    cursor: not-allowed;
  }

  .contact-me:hover,
  .contact-me:focus-visible{
    --_p: 0px;
    outline-color: var(--color2);
    outline-offset: .05em;
  }

  .contact-me:active {
    background: var(--color2);
    color: #fff;
  }
  .contact-me:active:disabled {
    background: none;
    color: #ff00ee;
  }
  .white-text {
    color: white;
  }
  @media (max-device-width: 660px) {
    .contact-container {
      padding: 10px;
      margin-right: 5px;
    }
  }
</style>